// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Grid from "@material-ui/core/Grid";

// Import Pages
import { libraryIcons } from '../../../autom/NewFlowLibraryAssetManager';
import { getImageColors, getShade } from '../../../../../../helpers/helper'
// Import CSS
import '../ModuleItem/ModuleItem.css';

const defaultLibraryImg = `default_library.png`

const LibraryItem = ({
    img,
    name,
    library,
    actions,
    handleDragStart,
    handleDragEnd
}) => {
    const { t } = useTranslation();

    const [expand, setExpand] = useState(false);
    const [dynamicBackgrounColor, setDynamicBackgrounColor] = useState('#666469');
    const [dynamicColor, setDynamicColor] = useState('white');
    const [shade, setShade] = useState('');

    useEffect(() => {
        getImageColors(img, (result) => {
            setDynamicBackgrounColor(result.background);
            setShade(getShade(result.background, 75));
            setDynamicColor(result.color);
        })
    }, []);

    return (
        <div className="library-item-container font-manrope">
            <div className="library-item-padding">
                <div className="ml-item-header library-item-header">
                    <div className="module-item-title-container">
                        <img src={img} className="library-img" alt={name} />
                        <span className="module-item-title">{name}</span>
                    </div>
                    {expand ? <KeyboardArrowUp className="module-item-expand" onClick={() => setExpand(false)} /> : <KeyboardArrowDown className="module-item-expand" onClick={() => setExpand(true)} />}
                </div>
                {
                    expand &&
                    <div className="module-item-content">
                        {
                            actions.length > 0 &&
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between" spacing={1}>
                                    {
                                        actions.map((action) => {
                                            let currentVersion = library.library_versions.filter(version => version.is_active);
                                            const action_name = library?.library_label?.includes('CUSTOM') ? action?.action_name :
                                                t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`);
                                            if (action.visible) {
                                                return (

                                                    <Grid item xs={12} sm={6}>
                                                        <div className='action-item-container'
                                                            onDragStart={(e) => handleDragStart(e,
                                                                {
                                                                    ...action,
                                                                    libraryLabel: library.library_label,
                                                                    libraryName: library.library_name,
                                                                    application_id: library.application_id,
                                                                    actionName: action.action_name,
                                                                    library_label: library.library_label,
                                                                    library_name: library.library_name,
                                                                    action_name: action.action_name,
                                                                    image: img,
                                                                    shade,
                                                                    fields: {},
                                                                    isDebugging: false,
                                                                    debugStatus: "",
                                                                    debugErrorMessage: "",
                                                                    version: currentVersion[0]?.version,
                                                                    versionId: currentVersion[0]?.id,
                                                                    actionId: action.id
                                                                }
                                                            )}
                                                            draggable={action.status}
                                                            onDragEnd={(e) => handleDragEnd(e,
                                                                {
                                                                    ...action,
                                                                    libraryLabel: library.library_label,
                                                                    libraryName: library.library_name,
                                                                    application_id: library.application_id,
                                                                    actionName: action.action_name,
                                                                    library_label: library.library_label,
                                                                    library_name: library.library_name,
                                                                    action_name: action.action_name,
                                                                    image: img,
                                                                    shade,
                                                                    fields: {},
                                                                    isDebugging: false,
                                                                    debugStatus: "",
                                                                    debugErrorMessage: "",
                                                                    version: currentVersion[0]?.version,
                                                                    versionId: currentVersion[0]?.id,
                                                                    actionId: action.id
                                                                }
                                                            )}
                                                        >
                                                            <img src={img} className="library-img-in-action" alt={name} />
                                                            <div className='action-item-name' style={{ backgroundColor: dynamicBackgrounColor, color: dynamicColor }}>
                                                                {action_name}
                                                            </div>
                                                        </div>

                                                    </Grid>
                                                )
                                            }
                                        })
                                    }
                                </Grid>
                            </Grid>

                        }
                    </div>
                }
            </div>
        </div >
    )
}

export default LibraryItem;